import React, { useState } from 'react';
import { Server, Zap, Database, Search } from 'lucide-react';
import './devoloperCard.css';
import CodeEditorDeveloperCard from './devoloperCard.tsx';

const developers = [
    {
        name: 'Amro Eid',
        position: 'Lead Developer & Data Scientist',
        avatar: '/assets/img/amroEF.jpeg',
        description: 'Code wrangler by day, data detective by night, turning chaos into clarity with scalable systems and a dash of algorithmic magic.',
        skills: ['Python', 'React', 'Node.js', 'Data Analysis', 'Machine Learning'],
        github: 'https://github.com/AmroEid77',
        linkedin: 'https://www.linkedin.com/in/amroeid77',
        favoriteCode: `
        function optimizeCode(code) {
            return code.split('').sort().join('');
        }
        // Just kidding! Real optimization is harder. 😉
            `
    },
    {
        name: ' Bara Mhana',
        position: 'Front-End Developer',
        avatar: '/assets/img/baraEF.jpg',
        description: 'Crafting pixel-perfect, responsive websites that feel like home. Coding with a touch of magic ✨.',
        skills: ['React.js', 'TypeScript', 'Node.js', 'Sketch', 'Tailwind CSS', 'User Research'],
        github: 'https://github.com/baramhana10',
        linkedin: 'https://www.linkedin.com/in/bara-mhana',
        favoriteCode: `
        .code-master {
        code-quality: "clean";
        responsiveness: "100%";
        bug-fixes: "done before you find them 🕵️‍♂️";
        }
            `
    },
    {
        name: 'Hossam shehadeh',
        position: 'DevOps Engineer',
        avatar: '/assets/img/HossamEF.jpeg',
        description: 'Infrastructure guru ensuring smooth deployments and optimal performance.',
        skills: ['Python', 'React', 'Node.js', 'Data Analysis', 'Machine Learning', 'Azure', 'Docker'],
        github: 'https://github.com/Hossam-Shehadeh',
        linkedin: 'https://www.linkedin.com/in/hossam-shehadeh/',
        favoriteCode: `
        pipeline {
            agent any
            stages {
                stage('Deploy') {
                    steps {
                        sh 'docker-compose up -d'
                        sh 'kubectl apply -f k8s-config.yml'
                        sh 'echo "Deployment successful! 🚀"'
                    }
                }
            }
        }
        `
    },
    {
        name: 'Abdullah Jamal ',
        position: 'Data Scientist',
        avatar: '/assets/img/abdullahEF.jpeg',
        description: 'Data whisperer by day, logic ninja by night, decoding patterns in data and crafting insights that inspire action. I turn complexity into simplicity with style.',
        skills: ['Python','.NET', 'React', 'Node.js', 'Data Analysis', 'Machine Learning'],
        github: 'https://github.com/AboodJamal',
        linkedin: 'https://www.linkedin.com/in/abdullahjamal99/',
        favoriteCode: `
    function simplifyChaos(chaos) {
        return chaos.join(' 🍫 '); // Because chocolate fixes everything
    }
    console.log(simplifyChaos(['bugs', 'errors', 'headaches'])); 
    // bugs 🍫 errors 🍫 headaches
`
    }
]
function About() {
    const [activeTab, setActiveTab] = useState('background');
    const [selectedDeveloper, setSelectedDeveloper] = useState(developers[0]);


    return (
        <div className="container mx-auto px-6 py-12">
            <h1 className="text-4xl font-bold mb-8 text-center gradient-text">About TweetInsight</h1>

            <div className="mb-8 flex justify-center space-x-4">
                <button
                    className={`px-4 py-2 rounded-full ${activeTab === 'background' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'} transition-colors duration-300`}
                    onClick={() => setActiveTab('background')}
                >
                    Background
                </button>
                <button
                    className={`px-4 py-2 rounded-full ${activeTab === 'tech' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'} transition-colors duration-300`}
                    onClick={() => setActiveTab('tech')}
                >
                    Technologies
                </button>
                <button
                    className={`px-4 py-2 rounded-full ${activeTab === 'usecases' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'} transition-colors duration-300`}
                    onClick={() => setActiveTab('usecases')}
                >
                    Use Cases
                </button>
                <button
                    className={`px-4 py-2 rounded-full ${activeTab === 'theTeam' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'} transition-colors duration-300`}
                    onClick={() => setActiveTab('theTeam')}
                >
                    Team
                </button>
            </div>

            {activeTab === 'background' && (
                <section className="mb-12 card p-8 animate-fadeIn">
                    <h2 className="text-2xl font-semibold mb-4 gradient-text">Project Background</h2>
                    <p className="text-gray-600 mb-4">
                        TweetInsight was born out of the need for real-time social media analysis in today's fast-paced digital world. Our system provides instant insights into Twitter trends, sentiments, and geographical patterns, enabling businesses and researchers to make data-driven decisions quickly.
                    </p>
                </section>
            )}

            {activeTab === 'tech' && (
                <section className="mb-12 animate-fadeIn">
                    <h2 className="text-2xl font-semibold mb-8 text-center gradient-text">Technologies Used</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            { name: "Apache Kafka", description: "For real-time data ingestion and streaming", icon: <Zap className="w-12 h-12 text-indigo-600" /> },
                            { name: "Apache Spark", description: "For high-speed, large-scale data processing", icon: <Server className="w-12 h-12 text-pink-500" /> },
                            { name: "Elasticsearch", description: "For scalable search and analytics on large datasets", icon: <Search className="w-12 h-12 text-yellow-500" /> },
                        ].map((tech, index) => (
                            <div key={index} className="card p-6 text-center group hover:bg-indigo-50 transition-all duration-300 transform hover:scale-105">
                                <div className="mb-4 flex justify-center transform group-hover:rotate-12 transition-transform duration-300">
                                    {tech.icon}
                                </div>
                                <h3 className="text-xl font-semibold mb-2 text-gray-800">{tech.name}</h3>
                                <p className="text-gray-600">{tech.description}</p>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {activeTab === 'usecases' && (
                <section className="mb-12 card p-8 animate-fadeIn">
                    <h2 className="text-2xl font-semibold mb-4 gradient-text">Use Cases</h2>
                    <ul className="list-disc list-inside text-gray-600 space-y-2">
                        <li>Real-time sentiment analysis for brand monitoring</li>
                        <li>Trend detection for marketing insights</li>
                        <li>Geographical analysis for targeted campaigns</li>
                        <li>Crisis management and public relations</li>
                        <li>Academic research on social media behavior</li>
                    </ul>
                </section>
            )}

            {activeTab === 'theTeam' && (
                <section className="mb-12 animate-fadeIn">
                    <h2 className="text-2xl font-semibold mb-8 text-center gradient-text">
                        Meet Our Team
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                        {developers.map((dev) => (
                            <button
                                key={dev.name}
                                className={`p-2 rounded-lg transition-all duration-300 ${selectedDeveloper?.name === dev.name
                                    ? "bg-gradient-to-r from-indigo-600 to-pink-500 text-white"
                                    : "bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
                                    }`}
                                onClick={() => setSelectedDeveloper(dev)}
                            >
                                {dev.name}
                            </button>
                        ))}
                    </div>
                    {selectedDeveloper && (
                        <CodeEditorDeveloperCard developer={selectedDeveloper} />
                    )}
                </section>



            )}

            <section className="card p-8">
                <h2 className="text-2xl font-semibold mb-4 gradient-text">Our Mission</h2>
                <p className="text-gray-600">
                    At TweetInsight, our mission is to empower organizations with real-time social media intelligence. We strive to provide accurate, timely, and actionable insights that drive informed decision-making in an increasingly connected world.
                </p>
            </section>
        </div>
    );
}

export default About;
